import { render, staticRenderFns } from "./wEditor.vue?vue&type=template&id=edbdb074&"
import script from "./wEditor.vue?vue&type=script&lang=js&"
export * from "./wEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports